import * as React from 'react';

import { Fecha } from 'src/componentes';
import { DatosPersona } from '../tipos';
import Campo from './Campo';
import CorreosYTelefonos from './CorreosYTelefonos';
import Direccion from './Direccion';
import Info from './Info';
import RutPasaporte from './RutPasaporte';

interface InformacionPersonalProps extends DatosPersona {
    titulo: string;
}
const InformacionPersonal: React.FunctionComponent<InformacionPersonalProps> = props => {
    const {
        titulo,
        id,
        nombreCompleto,
        correos,
        telefonos,
        direccionPersonal,
        direccionLaboral,
        fechaDeNacimiento,
        estadoCivil,
        facebook,
        ocupacion,
    } = props;
    return (
        <Info titulo={titulo}>
            <Campo etiqueta='Nombre' valor={nombreCompleto} />
            <RutPasaporte {...id} />
            <Direccion titulo='Dirección personal' {...direccionPersonal} />
            {direccionLaboral && <Direccion titulo='Dirección laboral' {...direccionLaboral} />}
            <CorreosYTelefonos correos={correos} telefonos={telefonos} />
            <Campo etiqueta='Dirección laboral' valor='' ocultar />
            <Campo etiqueta='Fecha de nacimiento' valor={<Fecha fecha={fechaDeNacimiento} />} />
            <Campo etiqueta='Estado civil' valor={estadoCivil} />
            {facebook && (
                <Campo
                    etiqueta='Facebook'
                    valor={
                        <a href={facebook} target='_blank'>
                            {facebook}
                        </a>
                    }
                />
            )}
            {ocupacion && <Campo etiqueta='Ocupación' valor={ocupacion} />}
        </Info>
    );
};

export default InformacionPersonal;



// WEBPACK FOOTER //
// ./src/modulos/Alumnos/paginas/FichaDeAlumno/paginas/InformacionGeneral/componentes/InformacionPersonal.tsx